import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { ProtectedRoute } from './services/access-control';
import { connect } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
// eslint-disable-next-line
import Offline from 'offline-js';

import Loader from './components/common/loader';
import Header from './components/header';
import Sidebar from './components/sidebar';

import SignIn from './containers/sign-in';
import TermsAndConditions from './containers/terms-and-conditions';

import NotFoundPage from './containers/not-found-page';

import SharedTokenSyncPage from './containers/shared-token-sync-page';

import AsyncComponent from './tools/async-component';
import { getRedirectAfterSignInPath } from './tools';
import SearchAssociatesUrls from './tools/search-associates-urls';

const AsyncCandidate = AsyncComponent(() =>
  import(/* webpackChunkName: 'candidate-module' */ './containers/candidate')
);

const AsyncSchools = AsyncComponent(() =>
  import(/* webpackChunkName: 'schools-module' */ './containers/schools')
);

const AsyncAdmin = AsyncComponent(() =>
  import(/* webpackChunkName: 'admin-module' */ './containers/admin')
);

const AsyncReference = AsyncComponent(() =>
  import(/* webpackChunkName: 'referee-module' */ './containers/references/reference')
);

const AsyncUserAccount = AsyncComponent(() =>
  import(/* webpackChunkName: 'user-account-module' */ './containers/user-account')
);

const AsyncHome = AsyncComponent(() =>
  import(/* webpackChunkName: 'home-module' */ './containers/home')
);

const AsyncForgotPassword = AsyncComponent(() =>
  import(/* webpackChunkName: 'forgot-password-module' */ './containers/password-recovery/forgot-password')
);

const AsyncResetPassword = AsyncComponent(() =>
  import(/* webpackChunkName: 'reset-password-module' */ './containers/password-recovery/reset-password')
);

const AsyncUserActivation = AsyncComponent(() =>
  import(/* webpackChunkName: 'user-activation-module' */ './containers/user-activation/user-activation')
);

const AsyncConfirmUserActivation = AsyncComponent(() =>
  import(/* webpackChunkName: 'confirm-user-activation-module' */ './containers/user-activation/confirm-user-activation')
);

const AsyncSchoolPublicVacancy = AsyncComponent(() =>
  import(/* webpackChunkName: 'school-public-vacancy-module' */ './containers/schools/vacancies/school-public-vacancy')
);

const AsyncPublicSchoolVacancies = AsyncComponent(() =>
  import(/* webpackChunkName: 'public-school-vacancies-module' */ './containers/schools/vacancies/public-school-vacancies')
);

const AsyncCandidateDocumentDownload = AsyncComponent(() =>
  import(/* webpachChunkName: 'candidate-document-download-module' */ './containers/candidate/candidate-document-download')
);

class App extends Component {
  constructor(props) {
    super(props);

    this.renderIndexPage = this.renderIndexPage.bind(this);
    this.renderAppContainer = this.renderAppContainer.bind(this);
  }

  renderIndexPage() {
    const { authUser } = this.props;

    if (authUser.get('isLoading')) {
      return (
        <div className="segment main-section">
          <Loader visible={true} />
        </div>
      );
    }

    return (
      <Redirect
        to={getRedirectAfterSignInPath(authUser.get('userType'))}
        push={true}
      />
    );
  }

  renderAppContainer() {
    const { pathname } = this.props.location;
    const isPublicPage = /^\/public($|\/$)/.test(pathname);

    return (
      <div className="app-container">
        <ProtectedRoute path="/" component={Sidebar} rule="sidebar:view" />
        <div
          className={`page-content-wrapper ${isPublicPage
            ? 'no-auth-user'
            : ''}`}
        >
          <div className="main-content">
            <Route path="/" component={Header} />
            <div className="content">
              <Switch>
                <ProtectedRoute
                  path="/candidate"
                  component={AsyncCandidate}
                  rule="candidate:view"
                  redirect
                />
                <ProtectedRoute
                  path="/schools"
                  component={AsyncSchools}
                  rule="schools:view"
                  redirect
                />
                <Route
                  exact
                  path="/user-activation"
                  component={AsyncUserActivation}
                />
                <Route
                  exact
                  path="/user-activation/:code"
                  component={AsyncConfirmUserActivation}
                />
                <ProtectedRoute
                  path="/user-account"
                  component={AsyncUserAccount}
                  rule="userAccount:view"
                  redirect
                />
                <Route exact path="/sign-in" component={SignIn} />
                <Route
                  exact
                  path="/forgot-password"
                  component={AsyncForgotPassword}
                />
                <Route
                  exact
                  path="/reset-password/:code"
                  component={AsyncResetPassword}
                />
                <Route exact path="/" render={this.renderIndexPage} />
                <Route exact path="/public" component={AsyncHome} />
                <Route
                  exact
                  path="/public/schools/:schoolId/vacancies"
                  component={AsyncPublicSchoolVacancies}
                />
                <Route
                  exact
                  path="/public/schools/:schoolId/vacancies/:vacancyId"
                  component={AsyncSchoolPublicVacancy}
                />
                <Route
                  exact
                  path="/public/terms-and-conditions"
                  component={TermsAndConditions}
                />
                <Route path="/references/:code" component={AsyncReference} />
                <ProtectedRoute
                  path="/admin"
                  component={AsyncAdmin}
                  rule="admin:view"
                  redirect
                />
                <ProtectedRoute
                  path="/candidate-document-download/schools/:schoolId/candidates/:candidateId/partner/documents/:documentId"
                  component={AsyncCandidateDocumentDownload}
                  rule="schools:view"
                  redirect
                />
                <Route component={NotFoundPage} />
              </Switch>
            </div>
          </div>
          <footer className="main-footer">
            <div className="container">
              <div className="pull-left">
                © {new Date().getFullYear()} APLī. All Rights Reserved
              </div>
              <div className="pull-right">
                Powered by{' '}
                <a href={SearchAssociatesUrls.getBaseUrl()} target="_blank">
                  Search Associates
                </a>
              </div>
            </div>
          </footer>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="root-container">
        <Switch>
          <Route path="/" render={this.renderAppContainer} />
        </Switch>
        <ReduxToastr
          timeOut={4000}
          newestOnTop={false}
          preventDuplicates
          position="top-center"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar
        />
        <SharedTokenSyncPage />
      </div>
    );
  }
}

export default connect(state => ({
  authUser: state.authUser
}))(App);



// WEBPACK FOOTER //
// ./src/app.js